<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="align-left">
            <small class="text-muted">Sales</small>
        </h3>
        <div class="dropdown-divider"></div><br />
        <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
        <app-data-search v-on:searching="search"></app-data-search>
        <div>
            <button type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button>
            <button type="button" class="btn btn-outline-info" @click="edit" style="margin-left: 20px;">Edit <i class="far fa-edit"></i></button>
            <button type="button" class="btn btn-outline-success" style="margin-left: 20px;" @click="preview">Preview <i class="fas fa-print"></i></button>
            <div style="float:right;">
                <button type="button" class="btn btn-outline-danger" style="margin-left: 20px;" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button>
            </div>
            
        </div>
        
        <br />
        <app-datatable :type="'view'" :elements="dtElements" :collections="sales" v-on:selectedRow="selectRow"></app-datatable>
        <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { sales } from '../../models/sales'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
        return {
            sales: [sales],
            dtElements: [
                {
                    title: 'Invoice No',
                    column: 'invoiceNo',
                    type: 'text'
                },
                {
                    title: 'Invoice Date',
                    column: 'date',
                    type: 'date'
                },
                {
                    title: 'Customer Name',
                    column: 'customerName',
                    type: 'text'
                },
                {
                    title: 'Grand Total',
                    column: 'grandTotal',
                    type: 'currency'
                },
                {
                    title: 'Created By',
                    column: 'createdBy',
                    type: 'text'
                },
            ],
            modalElements: {
                modalId: 'sales',
                title: 'Confirm',
                content: 'Are you sure to delete this data?',
                type: 'text-confirm'
            },
            selectedId: '',
            searchKey: '',
            pagination: {
                pageSize: 10,
                currentPage: 1
            }
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            const salesApi = api('sales/partial')
            const query = {
                params: {
                    searchKey: this.searchKey,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
            }
            this.sales = await salesApi.getWithQuery(query) 
        },
        add() {
            this.$router.push({ name: 'salesDetail' })
        },
        edit() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'salesDetail',
                    query: {
                        id: this.selectedId
                    }
                })
            }
        },
        preview() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'salesDetailReport',
                    query: {
                        id: this.selectedId
                    }
                })
            }
        },
        async del() {
            if(this.selectedId !== '') {
                const salesApi = api('sales')
                await salesApi.delete(this.selectedId)
                this.init()
            }
        },
        selectRow(id) {
            this.selectedId = id
        },
        changePage(payload) {
            this.pagination = payload
            this.init()
        },
        search(searchKey) {
            this.searchKey = searchKey
            this.init()
        }
    }
}
</script>